module.exports = __webpack_public_path__ + "/images/u_image-plus.4f8497c.png";